import Intercom, { boot, show, shutdown } from '@intercom/messenger-js-sdk';
import { fetchIntercomToken } from '../redux/actions/intercomActions';

function startIntercom(data) {
  const settings = {
    app_id: data.app_id,
    api_base: data.api_base || 'https://api-iam.intercom.io',
    region: data.region || 'us',
    user_id: data.user_id,
    name: data.name,
    email: data.email,
    created_at: data.created_at,
    intercom_user_jwt: data.token,
    hide_default_launcher: true
  };

  window.intercomSettings = settings;
  Intercom(settings);

  if (typeof window.Intercom === 'function') {
    window.Intercom('boot', settings);
  } else if (typeof boot === 'function') {
    boot(settings);
  }

  return settings;
}

function showMessenger() {
  if (typeof show === 'function') {
    show();
  }
  if (typeof window.Intercom === 'function') {
    window.Intercom('show');
  }
}

export function shutdownIntercom() {
  if (typeof shutdown === 'function') {
    shutdown();
  }
  if (typeof window.Intercom === 'function') {
    window.Intercom('shutdown');
  }
}

export async function bootIntercom() {
  const data = await fetchIntercomToken();
  if (!data?.enabled || !data.token || !data.app_id) {
    throw new Error('Intercom is not configured');
  }

  startIntercom(data);
  return data;
}

export async function openIntercomMessenger() {
  await bootIntercom();
  showMessenger();
  setTimeout(showMessenger, 800);
}
